import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';

import Dexie from 'dexie';
const db = new Dexie('imgEditorDb');
db.version(1).stores({
  images: 'id,image',
  previewImages: 'id,image',
});
export const GetPacReport = async (data, setPacsData) => {
  const updateIndexedDb = (GozareshList, pdfReport) => {
    db.previewImages
      .get(314)
      .then(function (image) {
        // // If the image and reportList property exist, update it
        image.image.GozareshList = GozareshList;
        image.image.pdfReport = pdfReport;
        return db.previewImages.put(image);
      })
      .then(function () {})
      .catch(function (error) {
        console.error('Error updating image: ' + error);
      });
  };

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_PACS_REPORT}`,
    false,
    {
      ...data,
    }
  ).then((response) => {
 

    if (response.data.resCode === 1) {
      setPacsData((prev) => ({
        ...prev,
        GozareshList: response.data.Data.GozareshList
          ? [...response.data.Data.GozareshList]
          : null,
        pdfReport: response.data.Data.pdfReport,
      }));

      updateIndexedDb(
        response.data.Data.GozareshList,
        response.data.Data.pdfReport
      );
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
